export default __webpack_public_path__ + "static/media/gb_sample_6.da9de19d.jpg";